import Link from "next/link";

import { formatCount } from "@/lib/format";

/** Die zwei Bereiche der Onpage-Optimierung (SPEC 4.2): Bestehende Analysen und Neue Analyse. */
export function OnpageTabs({ active, count }: { active: "list" | "new"; count?: number | null }) {
  const base = "inline-flex min-h-11 items-center px-4 text-sm";
  const on = "border-b-2 border-accent font-medium";
  return (
    <nav aria-label="Onpage-Bereiche" className="flex flex-wrap gap-1 border-b border-line">
      <Link
        href="/onpage"
        aria-current={active === "list" ? "page" : undefined}
        className={`${base} ${active === "list" ? on : "text-muted"}`}
      >
        Bestehende Analysen{count !== null && count !== undefined ? ` · ${formatCount(count)}` : ""}
      </Link>
      <Link
        href="/onpage/neu"
        aria-current={active === "new" ? "page" : undefined}
        className={`${base} ${active === "new" ? on : "text-muted"}`}
      >
        Neue Analyse
      </Link>
    </nav>
  );
}
